import {
    CREATE_PARTY_MASTER_REQUEST,
    CREATE_PARTY_MASTER_SUCCESS,
    CREATE_PARTY_MASTER_FAILURE,
    DELETE_PARTY_MASTER_REQUEST,
    DELETE_PARTY_MASTER_SUCCESS,
    DELETE_PARTY_MASTER_FAILURE,
    FETCH_SINGLE_PARTY_MASTER_REQUEST,
    FETCH_SINGLE_PARTY_MASTER_SUCCESS,
    FETCH_SINGLE_PARTY_MASTER_FAILURE,
    FETCH_PARTY_MASTER_REQUEST,
    FETCH_PARTY_MASTER_SUCCESS,
    FETCH_PARTY_MASTER_FAILURE,
    UPDATE_PARTY_MASTER_REQUEST,
    UPDATE_PARTY_MASTER_SUCCESS,
    UPDATE_PARTY_MASTER_FAILURE,
    RESET_PARTY_MASTER_INFO,
    CREATE_PARTY_MASTER_FORM,
    UPDATE_PARTY_MASTER_FORM,
    NAVIGATE_PARTY_DETAILS,
    NAVIGATE_PARTY_MASTER,
    FETCH_BANK_NAME_SUCCESS,
    FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_SUCCESS,
    SET_XLSX_DATA_OF_PARTY_MASTER,
    SET_ACTIVE_KEY_PARTY_MASTER,
    FETCH_PARTY_MASTER_PAN_FILE_REQUEST,
    FETCH_PARTY_MASTER_PAN_FILE_SUCCESS,
    FETCH_PARTY_MASTER_PAN_FILE_FAILURE,
    SET_PAN_FILE_NAME_PARTY_MASTER,
    SET_GST_FILE_NAME_PARTY_MASTER,
    FETCH_PARTY_MASTER_GST_FILE_SUCCESS,
    FETCH_PARTY_MASTER_GST_FILE_REQUEST,
    FETCH_PARTY_MASTER_GST_FILE_FAILURE,
    PARTY_MASTER_SET_ACTIVE_FAILURE,
    PARTY_MASTER_SET_ACTIVE_REQUEST
} from './partyMaster.actionsType';

export const PARTY_MASTER = 'partyMaster';

let initialState = {
    loading: false,
    partyMaster: [],
    activeKey: 1,
    panFileName: '',
    gstFileName: '',
    partyMasterform: {
        fldUnitType: [],
        panFileName: '',
        gstFileName: ''
    },
    selectedState: {},
    partyCategory: [],
    programType: [],
    excelData: [],
    bankName: [],
    errorMessage: '',
    partyId: {},
    isPartyDetails: false
};

export let partyMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PARTY_MASTER_REQUEST:
        case FETCH_PARTY_MASTER_PAN_FILE_REQUEST:
        case FETCH_PARTY_MASTER_GST_FILE_REQUEST:
        case CREATE_PARTY_MASTER_REQUEST:
        case UPDATE_PARTY_MASTER_REQUEST:
        case FETCH_SINGLE_PARTY_MASTER_REQUEST:
        case DELETE_PARTY_MASTER_REQUEST:
        case PARTY_MASTER_SET_ACTIVE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PARTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partyMaster: updatePayload
            };
        case FETCH_PARTY_MASTER_PAN_FILE_SUCCESS:
            var imageId = `data:image/png;base64,${updatePayload}`;
            var arr = imageId.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return {
                ...state,
                loading: false,
                panFileName: `data:image/png;base64,${updatePayload}`,
                partyMasterform: {
                    ...state.partyMasterform,
                    fldPANFile: updatePayload
                        ? new File([u8arr], `${state?.partyMasterform?.fldPANFileName}.png`, { type: `image/png` })
                        : ''
                }
            };
        case FETCH_PARTY_MASTER_GST_FILE_SUCCESS:
            var imageId = `data:image/png;base64,${updatePayload}`;
            var arr = imageId.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return {
                ...state,
                loading: false,
                gstFileName: `data:image/png;base64,${updatePayload}`,
                partyMasterform: {
                    ...state.partyMasterform,
                    fldGSTFile: updatePayload
                        ? new File([u8arr], `${state?.partyMasterform?.fldGSTFileName}.png`, { type: `image/png` })
                        : ''
                }
            };
        case FETCH_PROPERTY_DATA_FOR_PARTY_MASTER_SUCCESS:
            if (payload == 31) {
                return {
                    ...state,
                    loading: false,
                    partyCategory: updatePayload
                };
            } else if (payload == 23) {
                return {
                    ...state,
                    loading: false,
                    programType: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case FETCH_BANK_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                bankName: updatePayload
            };
        case SET_XLSX_DATA_OF_PARTY_MASTER:
            return {
                ...state,
                loading: false,
                excelData: payload
            };
        case SET_ACTIVE_KEY_PARTY_MASTER:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PAN_FILE_NAME_PARTY_MASTER:
            return {
                ...state,
                loading: false,
                panFileName: payload
            };
        case SET_GST_FILE_NAME_PARTY_MASTER:
            return {
                ...state,
                loading: false,
                gstFileName: payload
            };
        case CREATE_PARTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partyMasterform: {
                    fldUnitType: []
                }
            };
        case UPDATE_PARTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partyMasterform: {
                    fldUnitType: [],
                    panFileName: '',
                    gstFileName: ''
                }
            };
        case FETCH_SINGLE_PARTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partyMasterform: { ...updatePayload, fldisGstAvail: updatePayload.fldGSTNo === 'NA' ? true : false }
            };
        case DELETE_PARTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partyMasterform: {
                    fldUnitType: []
                }
            };
        case RESET_PARTY_MASTER_INFO:
            return {
                ...state,
                partyMasterform: {
                    fldUnitType: [],
                    panFileName: '',
                    gstFileName: ''
                }
            };
        case CREATE_PARTY_MASTER_FORM:
        case UPDATE_PARTY_MASTER_FORM:
            return {
                ...state,
                loading: false,
                partyMasterform: {
                    ...state.partyMasterform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PARTY_MASTER_FAILURE:
        case FETCH_PARTY_MASTER_PAN_FILE_FAILURE:
        case FETCH_PARTY_MASTER_GST_FILE_FAILURE:
        case CREATE_PARTY_MASTER_FAILURE:
        case UPDATE_PARTY_MASTER_FAILURE:
        case FETCH_SINGLE_PARTY_MASTER_FAILURE:
        case DELETE_PARTY_MASTER_FAILURE:
        case PARTY_MASTER_SET_ACTIVE_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PARTY_DETAILS:
            return {
                ...state,
                isPartyDetails: true,
                partyId: updatePayload.partyId
            };
        case NAVIGATE_PARTY_MASTER:
            return {
                ...state,
                isPartyDetails: false
            };
        default:
            return state;
    }
};
